import React, { useEffect, useRef, useState } from "react";
import { polygonCluster, polygonWsSymbol } from "../../utils/polygonSymbol";
import ChartComp from "../../components/chart/Chart";
import PostRichTextEditor from "../pages/PostRichTextEditor";
import { isQuillEmpty } from "../../utils/utils";
import { toast } from "react-toastify";
import PageContainer from "../../components/pages/PageContainer";
import { getCandlestickData } from "../../utils/api";
import {
  addChartNotification,
  deleteSavedChart,
  getChartStockDetails,
  getFollowersListApi,
  getSavedCharts,
  s3SingleUpload,
  saveChart,
  shareCartAsPostApi,
  shareSavedChartApi,
  searchStocksApi,
  getWatchlists,
  addStockToWatchlists,
  createPost,
} from "../../api/user";
import {
  initialValue,
  saveStateToLocalStorage,
} from "../../utils/localstorage";
import "react-toastify/dist/ReactToastify.css";
import Annotation from "../../components/setting/Annotation";
import ChartSettingsControl from "../../components/setting/ChartSettingsControl";
import ChartType from "../../components/setting/ChartType";
import Overlays from "../../components/setting/Overlays";
import Indicators from "../../components/setting/Indicators";
import html2canvas from "html2canvas";
import { useOutletContext } from "react-router";
import { SkeletonChart } from "../../components/Skeleton/Skeleton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { StockSummary } from "../../components/chart/stockSummary";
import { ChartToolBar } from "../../components/chart/chartToolBar";
import { TimeRangeButton } from "../../components/chart/timeRangeButton";
import { SavedCharts } from "../../components/chart/savedCharts";
import { SaveChartImage } from "../../components/chart/saveChartImage";
import { ChartError } from "../../components/chart/chartError";
import { ChartActionButtons } from "../../components/chart/chartActionButtons";
import { ChartTopSummary } from "../../components/chart/chartTopSummary";
import { AddNotification } from "../../components/chart/addNotification";
import MobileChartToolbar from "../../components/chart/MobileChartToolbar";
import FollowersListModal from "../../components/Modals/followersListModal";
import { fetchChartsData } from "../../pages/fetchChartsData";
import { sleep } from "../../utils/utils";
import GameSideBar from "../Games/GameSideBar";
import $ from "jquery";

// `initialValue.period` is the SHORT form ('1h'). That is correct for the two
// other screens that share the constant — char.jsx reads it as `setting?.period
// || '1m'`, and BuyChart.js keys a lookup table straight off it — so the constant
// itself must not change.
//
// This screen is the odd one out: it sends `setting.period` verbatim to
// pro.qushi.io/api/candlesticknew, which accepts only
// minute|hour|day|week|month. Asked for '1h' that endpoint answers **HTTP 200**
// carrying a 400-shaped body ({detail, status, title, type}), so axios never
// throws, the catch below never runs, the error body lands in `candleStick`, and
// `candleStick.Date.map(...)` throws "Cannot read properties of undefined".
// Because the catch then resets state back to `initialValue`, the bad period was
// put straight back and every reload of /:slug/charts failed the same way.
//
// This screen's own timeframe buttons already write the long form
// (`period: period.internal`) — only the seed was in the other dialect. So seed
// it in this screen's dialect and leave the shared constant alone.
const CHART_SEARCH_INITIAL = { ...initialValue, period: "hour" };


const ChartSearchSection = (props) => {
  const game_id = props?.game_id ?? null;
  const slug = props.slug ?? null;
  const initialLoaders = props.loaders ?? false;
  const [setting, setSetting] = useState(CHART_SEARCH_INITIAL);
  const [data, setData] = useState([]);
  const [gridSetting, setGridSetting] = useState({
    style: "ShortDot",
    opacity: "0.1",
    strokeWidth: "2",
    grid: false,
  });
  const captureRef = React.useRef();
  const [stockData, setstockData] = useState(null);
  const [isParamsSubmit, setIsParamSubmit] = useState(false);
  const [isIndicatorSubmit, setIsIndicatorSubmit] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [isOverlaySubmit, setIsOverlaySubmit] = useState(false);
  const [overlays, setOverlays] = useState([]);
  const [indicators, setIndicators] = useState([]);
  const [indicatorConfig, setIndicatorConfig] = useState([]);
  const [candleStick, setCandleStick] = useState([]);
  const [loader, setloader] = useState(false);
  const [overlayloader, setOverlayloader] = useState(false);
  const [indicatorloader, setIndicatorloader] = useState(false);
  const drawingCanva = useRef();
  const [error, seterror] = useState("");
  const [activeTab, setActiveTab] = useState(1);
  const [price, setPrice] = useState("");
  let tickerFromLocalStorage = localStorage.getItem("ticker");
  const [loaders, setloaders] = useState(true);
  const [savedCharts, setSavedCharts] = useState([]);
  const [preview, setPreview] = useState(false);
  const [preview1, setPreview1] = useState(false);
  const [activeImage, setActiveImage] = useState("");
  const [activeImage1, setActiveImage1] = useState(
    localStorage.getItem("tickerEventImage") || ""
  );
  const [isSlide, setIsSlide] = useState(false);
  const [sidebarToggle] = useOutletContext();
  const [stockPrice, setStockPrice] = useState("");
  const [quotes, setQuotes] = useState(null);
  const [followersList, setFollowersList] = useState([]);
  const [isFollowersOpen, setIsFollowersOpen] = useState(false);
  const [shareChartData, setShareChartData] = useState({});
  const [shareChartData1, setShareChartData1] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
  const initialState = {
    selectValue: "",
    inputValue: "",
    selectPosValue: "above",
  };
  const [rows, setRows] = useState([initialState]);
  const [selectedIndices, setSelectedIndices] = useState([]);
  const [chartId, setChartId] = useState(null); // State to store chart id

  const [watchlists, setWatchlists] = useState([]);
  const [showModal1, setShowModal1] = useState(false);
  const [selected1, setSelected1] = useState({});
  const [loading1, setLoading1] = useState(false);

  const [dropdownStates1, setDropdownStates1] = useState(
    savedCharts.map(() => false)
  );

  const toggleDropdown1 = (index) => {
    const newDropdownStates = [...dropdownStates1];
    newDropdownStates[index] = !newDropdownStates[index];
    setDropdownStates1(newDropdownStates);
  };

  // Clear data when ticker or period changes to prevent white screen with stale data
  useEffect(() => {
    console.log('[ChartSearchSection] Clearing data - ticker or period changed:', { ticker: tickerFromLocalStorage, period: setting?.period });
    setData([]);
    setCandleStick([]);
  }, [tickerFromLocalStorage, setting?.period]);

  // Clear fromChart flag when user arrives at chart page
  useEffect(() => {
    localStorage.removeItem('fromChart');
  }, []);

  useEffect(() => {
    if (localStorage.getItem("tickerEventImage")) {
      setPreview1(true);
    }
  }, []);

  useEffect(() => {
    const handleCustomProfileEvent = (event) => {
      localStorage.setItem("tickerEventImage", event?.detail?.imageChart);
      setPreview1(true);
      setActiveImage1(event?.detail?.imageChart);
    };
    window.addEventListener("tickerEventImage", handleCustomProfileEvent);
    // Remove on unmount: a leftover listener kept the unmounted page in memory.
    return () => window.removeEventListener("tickerEventImage", handleCustomProfileEvent);
  }, [window.addEventListener]);

  const handleShareToFollowers = async (id, index) => {
    setSelectedIndices([...selectedIndices, index]);
    const obj = {
      chart_id: shareChartData1?.id ? shareChartData1?.id : shareChartData?.id,
      users: id,
    };
    const res = await shareSavedChartApi(obj);
    if (res?.data?.status === 200) {
    } else {
      setSelectedIndices(selectedIndices.filter((i) => i !== index));
      toast.error(res?.data?.message);
    }
  };

  const handleShareCancel = () => {
    setIsFollowersOpen(false);
    setSelectedIds([]);
    setSelectedIndices([]);
  };

  const onShareChartClick = (chart) => {
    setShareChartData(chart);
    setIsFollowersOpen(true);
    setPreview(false);
    setSelectedIds([]);
  };

  const shareChartAsPost = async (chart) => {
    setChartId(chart?.id);
    setShowModalChart(true);
  };
  const [inputValue, setInputValue] = useState("");

  const [sharingInProgress, setSharingInProgress] = useState(false);

  const handleShare = async () => {
    // If sharing is already in progress, return early to prevent multiple clicks
    if (sharingInProgress) return;

    setSharingInProgress(true); // Set flag to indicate sharing is in progress

    // Composer now stores rich-text HTML; send empty string when blank.
    const description = isQuillEmpty(inputValue) ? "" : inputValue;

    try {
      const res = game_id
        ? await shareCartAsPostApi(
            shareChartData1?.id || chartId,
            description,
            game_id
          )
        : await shareCartAsPostApi(shareChartData1?.id || chartId, description);

      if (res?.data?.status === 200) {
        setPreview(false);
        setSelectedIds([]);
        setShowModalChart(false);
        toast.success(res?.data?.message);
        setInputValue("");
      } else {
        toast.error("Could not share the chart. Try again.");
      }
    } catch (error) {
      console.error("Error sharing cart:", error);
      toast.error("Could not share the chart. Try again.");
    } finally {
      setSharingInProgress(false); // Reset the flag whether successful or not
    }
  };
  useEffect(() => {
    getFollowersList();
  }, []);

  const getFollowersList = async () => {
    try {
      const res = await getFollowersListApi();
      if (res?.data?.status === 200) {
        setFollowersList(res?.data?.data?.data);
      }
    } catch (err) {}
  };

  useEffect(() => {
    const handleCustomProfileEvent = (event) => {
      if (event?.detail?.ticker) {
        setSetting({
          ...setting,
          symbol: event?.detail?.ticker,
          adlValue: "",
          adxValue: "",
          cciValue: "",
          cmfValue: "",
          macdValue: "",
          macdhValue: "",
          mfiValue: "",
          obvValue: "",
          ppoValue: "",
          pvoValue: "",
          rocValue: "",
          efiValue: "",
          stochValue: "",
          rsiValue: "",
          clearIndicator: true,
        });
        setRows([{ selectValue: "", inputValue: "", selectPosValue: "above" }]);
        localStorage.setItem("ticker", event?.detail?.ticker);
        // tickerFromLocalStorage = event?.detail?.ticker;
        return tickerFromLocalStorage;
      }
    };
    window.addEventListener("tickerEvent", handleCustomProfileEvent);
    // Remove on unmount: a leftover listener kept the unmounted page in memory.
    return () => window.removeEventListener("tickerEvent", handleCustomProfileEvent);
  }, [window.addEventListener]);

  const handlePreview1Close = () => {
    setPreview1(false);
    localStorage.removeItem("tickerEventImage");
  };

  // Ref to track last fetched stock to prevent duplicate API calls
  const lastFetchedStockRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      const stock = tickerFromLocalStorage
        ? tickerFromLocalStorage
        : setting.symbol;

      // Skip if same stock was already fetched
      if (lastFetchedStockRef.current === stock) {
        console.log('[ChartSearchSection] Skip duplicate getChartStockDetails for:', stock);
        return;
      }
      lastFetchedStockRef.current = stock;

      try {
        setloaders(true);

        // const response = await getChartStockDetails(stock);
                const searchString = stock?.toUpperCase() || "SPY";

        const category =
          searchString.startsWith("C:") ? "Forex" :
          searchString.startsWith("X:") ? "Crypto" :
          "Stocks";
        const response = await getChartStockDetails({
          ticker: searchString,
          category: category,
        });
        if (response?.data?.data?.ticker?.name) {
          setstockData(response.data.data);
          setloaders(false);
        } else {
          setloaders(false);
        }
      } catch (error) {
        setloaders(false);
        console.error("Error:", error);
      }
    };

    fetchData();
  }, [setting.symbol, tickerFromLocalStorage]);

  const handleInputChange = (event) => {
    setPrice(event.target.value);
  };

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  const handleAPICall = async () => {
    const priceP = price.trim();
    if (!priceP) {
      toast.error("Enter a price for the alert.");
      return;
    }
    setloaders(true);
    const data = {
      stock_symbol: tickerFromLocalStorage
        ? tickerFromLocalStorage
        : setting.symbol,
      notificaion_type: activeTab,
      amount: price.trim(),
    };
    try {
      const response = await addChartNotification(data);
      if (response) {
        setloaders(false);
        setPrice("");
        setIsNotificationOpen(false);
        toast.success("Price alert set.");
      }
    } catch (error) {
      setloaders(false);
      toast.error("Could not create the price alert. Try again.");
      console.error("Error:", error);
    }
  };
  const handleSaveNotification = () => {
    setIsNotificationOpen(false);
  };
  const handleClose = () => {
    setIsNotificationOpen(false);
  };

  const [isWidth, setISWidth] = useState(window.innerWidth < 890);
  useEffect(() => {
    setISWidth(window.innerWidth < 890);
  }, [window.innerWidth]);

  // Watchlist handlers
  const handleAddToWatchlist = async () => {
    try {
      setLoading1(true);
      const res = await getWatchlists();
      setWatchlists(res.data.watchlists);
      const init = {};
      res.data.watchlists.forEach(w => { init[w.id] = false });
      setSelected1(init);
      setShowModal1(true);
    } catch (err) {
      console.error("Error fetching watchlists:", err);
    } finally {
      setLoading1(false);
    }
  };

  const handleCheckboxChange = (id) => {
    setSelected1(prev => ({ ...prev, [id]: !prev[id] }));
  };

  const handleConfirm = async () => {
    const chosenIds = Object.keys(selected1).filter(id => selected1[id]);
    const symbol = tickerFromLocalStorage ? tickerFromLocalStorage : setting.symbol;

    console.log("Chosen Watchlists:", chosenIds);
    console.log("Symbol to add:", symbol);

    try {
      setLoading1(true);
      const res = await addStockToWatchlists(symbol, chosenIds);
      console.log("API Response:", res);
    } catch (err) {
      console.error("Failed to add stock:", err);
    } finally {
      setLoading1(false);
      setShowModal1(false);
    }
  };

  const checkForMobileDevice = () => {
    return /Mobi|Android/i.test(window.navigator.userAgent);
  };

  useEffect(() => {
    // Check if the user is on a mobile device
    if (checkForMobileDevice()) {
      setSetting({ ...setting, isMobile: true });
    } else {
      setSetting({ ...setting, isMobile: false });
    }
  }, []);

  const base64toFile = (base64String, filename) => {
    const byteString = atob(base64String.split(",")[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], { type: "image/jpeg" });
    return new File([blob], filename, { type: "image/jpeg" });
  };

  const captureElement_BKP = async () => {
    if (captureRef.current) {
      // console.log(captureRef.current, "capture");
      setloaders(true);
      html2canvas(captureRef.current).then(async (canvas) => {
        const image = canvas.toDataURL("image/png");
        const file = base64toFile(image, "file.jpg");
        const res = await s3SingleUpload(file);
        if (res?.data?.status === 200) {
          const convertedArray = res?.data?.data.map((str) => ({ image: str }));
          const res1 = await saveChart(
            convertedArray,
            tickerFromLocalStorage ? tickerFromLocalStorage : setting.symbol
          );
          if (res1?.data?.status === 200) {
            setloaders(false);
            toast.success(res1.data.message);
            fetchSavedCharts();
          } else {
            setloaders(false);
            toast.error(res1.data.message);
          }
        } else {
          setloaders(false);
          toast.error(res.data.message);
        }
      });
    }
  };

  const setLegendItemsMargins = (isSet = false) => {
    const textElements = document.querySelectorAll(".legend-item-text");
    const colorElements = document.querySelectorAll(".legend-item-color");

    if (isSet) {
      textElements.forEach((element) => {
        element.style.marginTop = "-10.5px"; // Adjust the value as needed
      });

      colorElements.forEach((element) => {
        element.style.marginTop = "2px"; // Adjust the value as needed
      });
    } else {
      textElements.forEach((element) => {
        element.style.marginTop = ""; // Adjust the value as needed
      });

      colorElements.forEach((element) => {
        element.style.marginTop = ""; // Adjust the value as needed
      });
    }
  };

  const captureElement = async () => {
    if (captureRef.current) {
      // console.log(captureRef.current, "capture");
      setloaders(true);
      setLegendItemsMargins(true);
      html2canvas(captureRef.current).then(async (canvas) => {
        const image = canvas.toDataURL("image/png");
        const file = base64toFile(image, "file.jpg");
        const res = await s3SingleUpload(file);
        setLegendItemsMargins();
        if (res?.data?.status === 200) {
          const convertedArray = res?.data?.data.map((str) => ({ image: str }));
          const res1 = await saveChart(
            convertedArray,
            tickerFromLocalStorage ? tickerFromLocalStorage : setting.symbol
          );
          if (res1?.data?.status === 200) {
            setloaders(false);
            toast.success(res1.data.message);
            fetchSavedCharts();
          } else {
            setloaders(false);
            toast.error(res1.data.message);
          }
        } else {
          setloaders(false);
          toast.error(res.data.message);
        }
      });
    }
  };

  // Direct share chart - captures and immediately opens share modal (without saving to saved charts or S3)
  const [directShareImageFile, setDirectShareImageFile] = useState(null);
  const [showDirectShareModal, setShowDirectShareModal] = useState(false);
  const [directShareDescription, setDirectShareDescription] = useState("");
  const [directShareInProgress, setDirectShareInProgress] = useState(false);

  const directShareChart = async () => {
    if (captureRef.current) {
      setloaders(true);
      setLegendItemsMargins(true);
      html2canvas(captureRef.current).then(async (canvas) => {
        const image = canvas.toDataURL("image/png");
        const file = base64toFile(image, "chart.png");
        setLegendItemsMargins();

        // Store the file and open modal (no S3 upload)
        setDirectShareImageFile(file);
        setloaders(false);
        setShowDirectShareModal(true);
      });
    }
  };

  const handleDirectShare = async () => {
    if (directShareInProgress || !directShareImageFile) return;
    setDirectShareInProgress(true);

    try {
      // Send image file directly - backend will save to local storage
      const formData = new FormData();
      formData.append('description', isQuillEmpty(directShareDescription) ? '' : directShareDescription);
      formData.append('caption', '');
      formData.append('tag', '');
      formData.append('post_status', '1');
      formData.append('post_images[]', directShareImageFile);

      const response = await createPost(formData);
      if (response?.status === 200) {
        setShowDirectShareModal(false);
        toast.success(
          response?.data?.data?.moderation_status === "pending_review"
            ? "Post submitted for review."
            : "Post published."
        );
        setDirectShareDescription("");
        setDirectShareImageFile(null);
      } else {
        toast.error("Could not share the chart. Try again.");
      }
    } catch (error) {
      console.error("Error sharing chart:", error);
      toast.error("Could not share the chart. Try again.");
    } finally {
      setDirectShareInProgress(false);
    }
  };

  const {
    fetchBollingerData,
    fetchPsarData,
    fetchSmaData,
    fetchEmaData,
    fetchAdlData,
    fetchAdxData,
    fetchRSIData,
    fetchStochData,
    fetchMacdhData,
    fetchCCIData,
    fetchPPOData,
    fetchCMFData,
    fetchPVOData,
    fetchMACDData,
    fetchMFIData,
    fetchROCData,
    fetchOBVData,
    fetchEFIData,
  } = fetchChartsData(
    tickerFromLocalStorage,
    setting,
    setOverlays,
    setOverlayloader,
    seterror,
    setIndicators,
    setIndicatorloader
  );

  useEffect(() => {
    const fetchOverlayData = async () => {
      if (isOverlaySubmit) {
        setIsOverlaySubmit(!isOverlaySubmit);
        try {
          for (const item of setting.overlayParams) {
            let index = setting.overlayParams.indexOf(item);
            if (
              item.inputValue === undefined ||
              item.inputValue === "" ||
              item.selectValue === ""
            ) {
              continue;
            }
            setOverlayloader(true);
            if (item.selectValue === "bb" && item.inputValue !== "") {
              fetchBollingerData(item, index);
            }
            if (item.selectValue === "sma" && item.inputValue !== "") {
              fetchSmaData(item, index);
            }
            if (item.selectValue === "ema" && item.inputValue !== "") {
              fetchEmaData(item, index);
            }
            if (item.selectValue === "psar" && item.inputValue !== "") {
              fetchPsarData(item, index);
            }
          }
        } catch (error) {
          toast.error("Could not load this indicator. Try again.");
          setOverlayloader(false);
          seterror(error?.message);
          console.error("Error fetching Bollinger Bands data:", error);
        }
      }
    };

    fetchOverlayData();
  }, [isOverlaySubmit, isParamsSubmit]);

  useEffect(() => {
    const fetchIndicatorData = async () => {
      for (const item of setting.indicatorParams) {
        await sleep(250);
        let index = setting.indicatorParams.indexOf(item);
        if (
          item.inputValue === undefined ||
          item.inputValue === "" ||
          item.selectValue === ""
        ) {
          continue;
        }
        setIndicatorloader(true);

        if (item.selectValue === "adl" && item.inputValue !== "") {
          fetchAdlData(item, index);
        }
        if (item.selectValue === "macdh" && item.inputValue !== "") {
          fetchMacdhData(item, index);
        }
        if (item.selectValue === "stoch" && item.inputValue !== "") {
          fetchStochData(item, index);
        }
        if (item.selectValue === "rsi" && item.inputValue !== "") {
          fetchRSIData(item, index);
        }
        if (item.selectValue === "adx" && item.inputValue !== "") {
          fetchAdxData(item, index);
        }
        if (item.selectValue === "cci" && item.inputValue !== "") {
          fetchCCIData(item, index);
        }
        if (item.selectValue === "macd" && item.inputValue !== "") {
          fetchMACDData(item, index);
        }
        if (item.selectValue === "mfi" && item.inputValue !== "") {
          fetchMFIData(item, index);
        }
        if (item.selectValue === "obv" && item.inputValue !== "") {
          fetchOBVData(item, index);
        }
        if (item.selectValue === "ppo" && item.inputValue !== "") {
          fetchPPOData(item, index);
        }
        if (item.selectValue === "efi" && item.inputValue !== "") {
          fetchEFIData(item, index);
        }
        if (item.selectValue === "roc" && item.inputValue !== "") {
          fetchROCData(item, index);
        }
        if (item.selectValue === "pvo" && item.inputValue !== "") {
          fetchPVOData(item, index);
        }
        if (item.selectValue === "cmf" && item.inputValue !== "") {
          fetchCMFData(item, index);
        }
      }
    };
    fetchIndicatorData();
  }, [isIndicatorSubmit, isParamsSubmit]);

  useEffect(() => {
    const fetchIndicatorData = async () => {
      let updateList = [];
      try {
        for (const item of setting.indicatorParams) {
          let index = setting.indicatorParams.indexOf(item);
          if (
            item.inputValue === undefined ||
            item.inputValue === "" ||
            item.selectValue === ""
          ) {
            continue;
          }
          let indicatorItem = {
            id: "",
            yAccessor: "",
            strokeStyle: "",
            yExtents: "",
            position: "",
            lineConfig: [],
          };
          if (item.selectValue === "adl" && item.inputValue !== "") {
            indicatorItem.id = "ADL";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d?.indicators[index]?.adl?.ad;
            indicatorItem.yExtents = (d) => d?.indicators[index]?.adl?.ad;
            indicatorItem.strokeStyle = "#ff7f0e";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: true,
                yAccessor: (d) => d?.indicators[index]?.adl?.ad,
                strokeStyle: "#ff7f0e",
              },
            ];
            updateList.push(indicatorItem);
          }
          if (item.selectValue === "macdh" && item.inputValue !== "") {
            indicatorItem.id = "MACDH";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d.indicators[index]?.macdh?.macdh;
            indicatorItem.yExtents = (d) => d.indicators[index]?.macdh?.macdh;
            indicatorItem.strokeStyle = "#ff7f0e";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: false,
                yAccessor: (d) => d.indicators[index].macdh?.macdh,
                strokeStyle: "#ff7f0e",
              },
            ];
            updateList.push(indicatorItem);
          }
          if (item.selectValue === "stoch" && item.inputValue !== "") {
            indicatorItem.id = "STOCH";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d.indicators[index]?.stoch?.stoch;
            indicatorItem.yExtents = (d) => d.indicators[index]?.stoch?.stoch;
            indicatorItem.strokeStyle = "#ff7f0e";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.stoch?.stoch,
                strokeStyle: "#ff7f0e",
              },
            ];
            updateList.push(indicatorItem);
          }
          if (item.selectValue === "rsi" && item.inputValue !== "") {
            indicatorItem.id = "RSI";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d.indicators[index]?.rsi?.rsi;
            indicatorItem.yExtents = (d) => d.indicators[index]?.rsi?.rsi;
            indicatorItem.strokeStyle = "#ff7f0e";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.rsi?.rsi,
                strokeStyle: "#ff7f0e",
              },
            ];
            updateList.push(indicatorItem);
          }
          if (item.selectValue === "adx" && item.inputValue !== "") {
            indicatorItem.id = "ADX";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d.indicators[index]?.adl?.adx;
            indicatorItem.yExtents = (d) => [
              Math.min(
                d.indicators[index]?.adx?.adx,
                d.indicators[index]?.adx?.dmn,
                d.indicators[index]?.adx?.dmp
              ),
              Math.max(
                d.indicators[index]?.adx?.adx,
                d.indicators[index]?.adx?.dmn,
                d.indicators[index]?.adx?.dmp
              ),
            ];
            indicatorItem.strokeStyle = "#2ca02c";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.adx?.adx,
                strokeStyle: "#00FF00",
              },
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.adx?.dmn,
                strokeStyle: "#0000FF",
              },
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.adx?.dmp,
                strokeStyle: "#FF0000",
              },
            ];
            updateList.push(indicatorItem);
          }
          if (item.selectValue === "cci" && item.inputValue !== "") {
            indicatorItem.id = "CCI";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d.indicators[index]?.cci?.cci;
            indicatorItem.yExtents = (d) => d.indicators[index]?.cci?.cci;
            indicatorItem.strokeStyle = "#FF00FF";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.cci?.cci,
                strokeStyle: "#FF00FF",
              },
            ];
            updateList.push(indicatorItem);
          }

          if (item.selectValue === "fi" && item.inputValue !== "") {
            setting.enableSSAR = true;
          }
          if (item.selectValue === "macd" && item.inputValue !== "") {
            indicatorItem.id = "MACD";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d.indicators[index].macd.macd;
            indicatorItem.yExtents = (d) => [
              Math.min(
                d.indicators[index]?.macd?.macd,
                d.indicators[index]?.macd?.macdh,
                d.indicators[index]?.macd.macds
              ),
              Math.max(
                d.indicators[index]?.macd?.macd,
                d.indicators[index]?.macd?.macdh,
                d.indicators[index]?.macd.macds
              ),
            ];
            indicatorItem.strokeStyle = "#FFC0CB";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.macd?.macd,
                strokeStyle: "#00FF00",
              },

              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.macd?.macds,
                strokeStyle: "#FF0000",
              },
            ];
            updateList.push(indicatorItem);
          }
          if (item.selectValue === "mfi" && item.inputValue !== "") {
            indicatorItem.id = "MFI";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d.indicators[index]?.mfi?.mfi;
            indicatorItem.yExtents = (d) => d.indicators[index]?.mfi?.mfi;
            indicatorItem.strokeStyle = "#FF0000";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.mfi?.mfi,
                strokeStyle: "#FF0000",
              },
            ];
            updateList.push(indicatorItem);
          }
          if (item.selectValue === "obv" && item.inputValue !== "") {
            indicatorItem.id = "OBV";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d.indicators[index]?.obv?.obv;
            indicatorItem.yExtents = (d) => d.indicators[index]?.obv?.obv;
            indicatorItem.strokeStyle = "#800080";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.obv?.obv,
                strokeStyle: "#800080",
              },
            ];
            updateList.push(indicatorItem);
          }
          if (item.selectValue === "ppo" && item.inputValue !== "") {
            indicatorItem.id = "PPO";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d.indicators[index]?.ppo?.ppo;
            indicatorItem.yExtents = (d) => d.indicators[index]?.ppo?.ppo;
            indicatorItem.strokeStyle = "#FF0000";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.ppo?.ppo,
                strokeStyle: "#FF0000",
              },
            ];
            updateList.push(indicatorItem);
          }
          if (item.selectValue === "efi" && item.inputValue !== "") {
            indicatorItem.id = "EFI";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d.indicators[index]?.efi?.efi;
            indicatorItem.yExtents = (d) => d.indicators[index]?.efi?.efi;
            indicatorItem.strokeStyle = "#0000FF";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.efi?.efi,
                strokeStyle: "#0000FF",
              },
            ];
            updateList.push(indicatorItem);
          }
          if (item.selectValue === "roc" && item.inputValue !== "") {
            indicatorItem.id = "ROC";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d.indicators[index]?.roc?.roc;
            indicatorItem.yExtents = (d) => d.indicators[index]?.roc?.roc;
            indicatorItem.strokeStyle = "#2ca02c";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.roc?.roc,
                strokeStyle: "#2ca02c",
              },
            ];
            updateList.push(indicatorItem);
          }
          if (item.selectValue === "pvo" && item.inputValue !== "") {
            indicatorItem.id = "PVO";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d.indicators[index]?.pvo?.pvo;
            indicatorItem.yExtents = (d) => d.indicators[index]?.pvo?.pvo;
            indicatorItem.strokeStyle = "#FFA500";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.pvo?.pvo,
                strokeStyle: "#FFA500",
              },
            ];
            updateList.push(indicatorItem);
          }
          if (item.selectValue === "cmf" && item.inputValue !== "") {
            indicatorItem.id = "CMF";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d.indicators[index]?.cmf?.cmf;
            indicatorItem.yExtents = (d) => d.indicators[index]?.cmf?.cmf;
            indicatorItem.strokeStyle = "#00FF00";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.cmf?.cmf,
                strokeStyle: "#00FF00",
              },
            ];
            updateList.push(indicatorItem);
          }
        }
        setIndicatorConfig(updateList);
      } catch (error) {
        toast.error("Could not load this indicator. Try again.");
        setIndicatorloader(false);
        seterror(error?.message);
        console.error("Error fetching indicator data:", error);
      }
    };

    fetchIndicatorData();
  }, [indicators]);

  useEffect(() => {
    const fetchCandlestickData = async () => {
      const candlestickParams = {
        symbol: tickerFromLocalStorage
          ? tickerFromLocalStorage
          : setting.symbol,
        startDate: setting.startDate,
        period: setting.period,
        multiplier: setting?.multiplier,
      };
      try {
        setloader(true);
        if (setting.indicatorParams.length > 0) {
          setIsIndicatorSubmit(!isIndicatorSubmit);
        }
        if (setting.overlayParams.length > 0) {
          setIsOverlaySubmit(!isOverlaySubmit);
        }
        const data = await getCandlestickData(
          ...Object.values(candlestickParams)
        );
        setCandleStick(data);
      } catch (error) {
        setSetting(CHART_SEARCH_INITIAL);
        setCandleStick([]);
        toast.error("Could not load chart prices. Try again.");
        seterror("Something went wrong, please refresh the screen");
        setloader(false);
        console.error(
          "Error fetching Candlestick data:",
          error.response.data.error || error.message
        );
      }
    };
    if (tickerFromLocalStorage || setting?.symbol) {
      fetchCandlestickData();
    }
  }, [isParamsSubmit, tickerFromLocalStorage, setting?.symbol]);

  useEffect(() => {
    fetchSavedCharts();
  }, []);

  const fetchSavedCharts = async () => {
    try {
      const response = await getSavedCharts();
      if (response && response?.data && response?.data?.status === 200) {
        setSavedCharts(response.data.data.data);
      } else {
      }
    } catch (error) {
      console.error("Error fetching saved posts:", error);
    }
  };

  const handleSlideStart = () => {
    setIsSlide(true);
  };

  const handleSlideEnd = () => {
    setIsSlide(false);
  };

  const handleSavedChartClick = (chart) => {
    setShareChartData(chart);
    setChartId(chart?.id);
    setShareChartData1(chart);
    setActiveImage(chart?.image);
    setPreview(true);
  };
  const [showModal, setShowModal] = useState(false);
  const [showModalChart, setShowModalChart] = useState(false);

  const [chartToDelete, setChartToDelete] = useState(null);

  const handleDeleteChart = async () => {
    try {
      const response = await deleteSavedChart(chartToDelete.id);
      if (response?.data?.data) {
        console.log(response);
        toast.success(response.data.message);
        fetchSavedCharts();
      }
    } catch (error) {
      console.error("Error deleting saved chart:", error);
    } finally {
      setShowModal(false);
    }
  };

  const onShareChartDeleteClick = (chart) => {
    setChartToDelete(chart);
    setShowModal(true);
  };

  useEffect(() => {
    try {
      // Guard on the shape we actually consume, not just "is it non-empty".
      // The endpoint can answer 200 with an error object (see the note on
      // CHART_SEARCH_INITIAL), which is non-empty but has no `Date` array — that
      // used to reach `.map` and throw.
      if (Array.isArray(candleStick?.Date)) {
        const mergedResponse = candleStick.Date.map((date, index) => {
          const mainObject = {
            key: index,
            date: new Date(date),
            open: candleStick.Open[index],
            high: candleStick.High[index],
            low: candleStick.Low[index],
            close: candleStick.Close[index],
            volume: candleStick.Volume[index],
            chart: [],
            indicators: [],
          };

          indicators.map((indicator, i) => {
            switch (indicator.type) {
              case "adl":
                mainObject["indicators"][i] = {
                  adl: {
                    ad: indicator.data?.[index]?.AD ?? null,
                    date: indicator.data?.[index]?.timestamp ?? null,
                  },
                };
                break;
              case "adx":
                mainObject["indicators"][i] = {
                  adx: {
                    adx: indicator.data?.[index]?.ADX ?? null,
                    dmn: indicator.data?.[index]?.DMN ?? null,
                    dmp: indicator.data?.[index]?.DMP ?? null,
                    date: indicator.data?.[index]?.timestamp ?? null,
                  },
                };
                break;
              case "cci":
                mainObject["indicators"][i] = {
                  cci: {
                    date: indicator.data?.[index]?.timestamp ?? null,
                    cci: indicator.data?.[index]?.CCI ?? null,
                  },
                };
                break;
              case "cmf":
                mainObject["indicators"][i] = {
                  cmf: {
                    date: indicator.data?.[index]?.timestamp ?? null,
                    cmf: indicator.data?.[index]?.CMF ?? null,
                  },
                };
                break;
              case "macd":
                mainObject["indicators"][i] = {
                  macd: {
                    macd: indicator.data?.[index]?.MACD ?? null,
                    macdh: indicator.data?.[index]?.MACDh ?? null,
                    macds: indicator.data?.[index]?.MACDs ?? null,
                    date: indicator.data?.[index]?.timestamp ?? null,
                  },
                };
                break;
              case "macdh":
                mainObject["indicators"][i] = {
                  macdh: {
                    data: indicator.data,
                    date: indicator.data?.[index]?.timestamp ?? null,
                    macdh: indicator.data?.[index]?.MACDh ?? null,
                  },
                };
                break;
              case "mfi":
                mainObject["indicators"][i] = {
                  mfi: {
                    mfi: indicator.data?.[index]?.MFI ?? null,
                    date: indicator.data?.[index]?.timestamp ?? null,
                  },
                };
                break;
              case "obv":
                mainObject["indicators"][i] = {
                  obv: {
                    date: indicator.data?.[index]?.timestamp ?? null,
                    obv: indicator.data?.[index]?.OBV ?? null,
                  },
                };
                break;
              case "ppo":
                mainObject["indicators"][i] = {
                  ppo: {
                    ppo: indicator.data?.[index]?.PPO ?? null,
                    ppoh: indicator.data?.[index]?.PPOh ?? null,
                    ppos: indicator.data?.[index]?.PPOs ?? null,
                    date: indicator.data?.[index]?.timestamp ?? null,
                  },
                };
                break;
              case "pvo":
                mainObject["indicators"][i] = {
                  pvo: {
                    pvo: indicator.data?.[index]?.PVO ?? null,
                    pvoh: indicator.data?.[index]?.PVOh ?? null,
                    pvos: indicator.data?.[index]?.PVOs ?? null,
                    date: indicator.data?.[index]?.timestamp ?? null,
                  },
                };
                break;
              case "roc":
                mainObject["indicators"][i] = {
                  roc: {
                    roc: indicator.data?.[index]?.ROC ?? null,
                    date: indicator.data?.[index]?.timestamp ?? null,
                  },
                };
                break;
              case "efi":
                mainObject["indicators"][i] = {
                  efi: {
                    efi: indicator.data?.[index]?.EFI ?? null,
                    date: indicator.data?.[index]?.timestamp ?? null,
                  },
                };
                break;
              case "stoch":
                mainObject["indicators"][i] = {
                  stoch: {
                    date: indicator.data?.[index]?.timestamp ?? null,
                    stoch: indicator.data?.[index]?.STOCHk ?? null,
                  },
                };
                break;
              case "rsi":
                mainObject["indicators"][i] = {
                  rsi: {
                    date: indicator.data?.[index]?.timestamp ?? null,
                    rsi: indicator.data?.[index]?.RSI ?? null,
                  },
                };
                break;
            }
          });
          overlays.map((overlay, i) => {
            switch (overlay.type) {
              case "bb":
                mainObject["chart"][i] = {
                  bb: {
                    top: overlay.data.BBU?.[index] ?? null,
                    middle: overlay.data.BBM?.[index] ?? null,
                    bottom: overlay.data.BBL?.[index] ?? null,
                  },
                };
                break;
              case "sma":
                mainObject["chart"][i] = {
                  sma: {
                    sma: overlay.data?.SMA?.[index] ?? null,
                    close: overlay.data?.Close?.[index] ?? null,
                    date: overlay.data?.Date?.[index] ?? null,
                  },
                };
                break;
              case "ema":
                mainObject["chart"][i] = {
                  ema: {
                    ema: overlay.data?.EMA?.[index] ?? null,
                    close: overlay.data?.Close?.[index] ?? null,
                    date: overlay.data?.Date?.[index] ?? null,
                  },
                };
                break;
              case "psar":
                mainObject["chart"][i] = {
                  psar: {
                    date: overlay.data?.[index]?.timestamp ?? null,
                    psarl: overlay.data?.[index]?.PSARl ?? null,
                    psars: overlay.data?.[index]?.PSARs ?? null,
                  },
                };
                break;
            }
          });
          return mainObject;
        });
        setOverlayloader(false);
        // setIndicatorData(false);

        setData(mergedResponse);
        setloader(false);
      }
    } catch (error) {
      seterror(
        error?.message ? "Something went wrong; please refresh the screen" : ""
      );
      setloader(false);
      console.error("Error occured while getting correct formate", error);
    }
  }, [overlays, candleStick, indicators]);

  useEffect(() => {
    saveStateToLocalStorage(setting);
  }, [setting]);

  function scrollToOptions() {
    // Get the element with the specified class name
    const element = document.querySelector(`.chart-options`);

    // Get the element's top position relative to the document
    const elementTop = element.offsetTop;

    // Scroll to the element smoothly
    window.scrollTo({
      top: elementTop,
      behavior: "smooth",
    });
  }

  function openAnnotations() {
    setSetting((prevSetting) => ({
      ...prevSetting,
      ["drawMode"]: !setting.drawMode,
    }));
  }

  const formatMarketCap = (value) => {
    const suffixes = ["", "K", "M", "B", "T"];
    const suffixNum = Math.floor(("" + value).length / 3);
    let shortValue = parseFloat(
      (suffixNum !== 0 ? value / Math.pow(1000, suffixNum) : value).toPrecision(
        2
      )
    );
    if (shortValue % 1 !== 0) {
      shortValue = shortValue.toFixed(2);
    }
    return shortValue + (suffixes[suffixNum] ?? "");
  };
  const isMobileView = document.body.clientWidth <= 768;

  const periods = [
    { id: 1, display: "1min", internal: "minute", period: "1m", multiplier: 1 },
    { id: 2, display: "2min", internal: "minute", period: "2m", multiplier: 2 },
    { id: 3, display: "5min", internal: "minute", period: "5m", multiplier: 5 },
    {
      id: 4,
      display: "15min",
      internal: "minute",
      period: "15m",
      multiplier: 15,
    },
    {
      id: 5,
      display: "30min",
      internal: "minute",
      period: "30m",
      multiplier: 30,
    },
    { id: 6, display: "1h", internal: "hour", period: "1h", multiplier: 1 },
    { id: 7, display: "4h", internal: "hour", period: "4h", multiplier: 4 },
    { id: 8, display: "1D", internal: "day" },
    { id: 9, display: "1W", internal: "week" },
    { id: 10, display: "1M", internal: "month" },
  ];

const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    arrows: !isMobileView, // Corrected the key from `arrow` to `arrows`
    slidesToShow:  isMobileView ? 1: 3, // Adjusts slidesToShow dynamically
    slidesToScroll: 1,
    prevArrow: (
      <ArrowButton
        imgSrc={faChevronLeft}
        type="left"
        isMobileView={isMobileView} // Fixed variable name
      />
    ),
    nextArrow: (
      <ArrowButton
        imgSrc={faChevronRight}
        type="right"
        isMobileView={isMobileView} // Fixed variable name
      />
    ),

  };

  const [scButton, setScButton] = useState(false);

  //const apiKey = process.env.REACT_APP_API_KEY;
    const apiKey = process.env.REACT_APP_API_KEY;
  useEffect(() => {
      const wsPath = polygonCluster(tickerFromLocalStorage);
      // Channel form, not the REST ticker — see utils/polygonSymbol.
      const wsSymbol = polygonWsSymbol(tickerFromLocalStorage);

  const ws = new WebSocket(`wss://business.polygon.io/${wsPath}`);

    ws.onopen = () => {
      ws.send(JSON.stringify({ action: "auth", params: apiKey }));
      ws.send(
        JSON.stringify({
          action: "subscribe",
          params: `FMV.${wsSymbol}`,
        })
      );
      ws.send(
        JSON.stringify({
          action: "subscribe",
          params: `Q.${wsSymbol}`,
        })
      );
      ws.send(
        JSON.stringify({
          action: "subscribe",
          params: `AM.${wsSymbol}`,
        })
      );
    };

    ws.onmessage = (event) => {
      const response = JSON.parse(event.data);
      response.forEach((msg) => {
        if (msg.ev === "FMV") {
          setStockPrice(msg.fmv ? msg.fmv.toFixed(2) : "N/A");
        } else if (msg.ev === "Q") {
          setQuotes(msg);
        } else if (msg.ev === "AM") {
        }
      });
    };

    ws.onerror = (error) => {
      console.error("WebSocket Error: ", error);
    };

    return () => {
      ws.close();
    };
  }, [apiKey, tickerFromLocalStorage]);

  return (
    <>
      <PageContainer gamePage={game_id && true}>
        {game_id && <GameSideBar activeMenu="charts" slug={slug} />}

        <div>
          {/* Chart rectangle at the chart's real height — the page chrome and
              toolbar stay put instead of the whole screen dimming. */}
          {/* Gated on an empty dataset: with a chart already on screen a
              refresh swaps it in place rather than reverting to grey. */}
          {loaders && data.length === 0 ? (
            <SkeletonChart height={520} className="mt-4" />
          ) : (
            ""
          )}
          {data.length > 0 ? (
            <>
              <ChartTopSummary
                mobileView={isMobileView}
                stockData={stockData}
                tickerFromLocalStorage={tickerFromLocalStorage}
                setting={setting}
                stockPrice={stockPrice}
                indicatorConfig={indicatorConfig}
              />
              <div id="chart-component">
                <div
                  className="grow shrink relative top-4"
                  id="chart-container"
                  ref={captureRef}
                >
                  <Annotation
                    setting={setting}
                    setSetting={setSetting}
                    drawingCanva={drawingCanva}
                  />
                  <ChartComp
                    initialData={data}
                    setting={setting}
                    indicatorConfig={indicatorConfig}
                    drawingCanva={drawingCanva}
                    gridSetting={gridSetting}
                    setSetting={setSetting}
                    setIndicatorConfig={setIndicatorConfig}
                    symbol={
                      tickerFromLocalStorage
                        ? tickerFromLocalStorage
                        : setting.symbol
                    }
                  />
                </div>
              </div>

              {/* Mobile Chart Toolbar - Shown only on mobile, below the chart */}
              <MobileChartToolbar
                selectedStock={tickerFromLocalStorage}
                setting={setting}
                onStockSelect={async (stock) => {
                  // Skip if same stock already selected
                  if (lastFetchedStockRef.current === stock.symbol) {
                    console.log('[ChartSearchSection] onStockSelect - Skip duplicate:', stock.symbol);
                    return;
                  }

                  setloaders(true);
                  try {
                    const res = await searchStocksApi({ search: stock.symbol, category: stock.category });
                    if (res?.data?.data?.length > 0) {
                      // Update ref BEFORE API call to prevent duplicate call from useEffect
                      lastFetchedStockRef.current = stock.symbol;

                      localStorage.setItem("ticker", stock.symbol);

                      // Fetch detailed stock data to update the price display
                      const detailRes = await getChartStockDetails({
                        ticker: stock.symbol,
                        category: stock.category,
                      });
                      console.log("MobileChartToolbar - getChartStockDetails response:", detailRes?.data?.data);
                      if (detailRes?.data?.data?.ticker?.name) {
                        setstockData(detailRes.data.data);
                      }

                      // Update setting.symbol to trigger chart data refetch (candlestick)
                      setSetting(prev => ({
                        ...prev,
                        symbol: stock.symbol,
                      }));

                      // Dispatch tickerEvent for other components that might need it
                      // But the stock-details API was already called above, so listeners should skip
                      const myCustomEvent = new CustomEvent("tickerEvent", {
                        detail: { ticker: stock.symbol },
                      });
                      window.dispatchEvent(myCustomEvent);
                    }
                  } catch (error) {
                    console.error("Error searching stock:", error);
                  } finally {
                    setloaders(false);
                  }
                }}
                onPeriodSelect={(period) => {
                  setSetting({
                    ...setting,
                    period: period.internal,
                    multiplier: period.multiplier,
                    periodID: period.id,
                  });
                  setIsParamSubmit(!isParamsSubmit);
                }}
                onPencilClick={openAnnotations}
                onIndicatorsClick={scrollToOptions}
                onMenuClick={scrollToOptions}
                onAlertClick={() => setIsNotificationOpen(true)}
                onOverlayUpdate={() => setIsOverlaySubmit(!isOverlaySubmit)}
                onIndicatorUpdate={() => setIsIndicatorSubmit(!isIndicatorSubmit)}
                onWatchlistClick={handleAddToWatchlist}
                onSaveChartClick={captureElement}
                onDirectShareChart={directShareChart}
                savedCharts={savedCharts}
                onSavedChartClick={handleSavedChartClick}
                onDeleteChart={onShareChartDeleteClick}
                onShareChartAsPost={shareChartAsPost}
                setSetting={setSetting}
                indicatorRows={rows}
                setIndicatorRows={setRows}
              />

              <div
                className={
                  isMobileView
                    ? "chart-tools mt-8 ml-4"
                    : "chart-tools mt-4 chart-toolbar-offset"
                }
              >
                <ChartToolBar
                  periods={periods}
                  callbackfn={(period) => (
                    <TimeRangeButton
                      key={period?.id}
                      period={period}
                      setting={setting}
                      onClick={() => {
                        setSetting({
                          ...setting,
                          period: period?.internal,
                          multiplier: period?.multiplier,
                          periodID: period?.id,
                        });
                        setIsParamSubmit(!isParamsSubmit);
                      }}
                    />
                  )}
                  onClick={openAnnotations}
                  onClick1={scrollToOptions}
                />
              </div>
              <StockSummary
                stockData={stockData}
                formatMarketCap={formatMarketCap(stockData?.ticker?.mkt_cap)}
              />

              <ChartActionButtons
                onClick={() => setIsNotificationOpen(true)}
                onClick1={captureElement}
                onClick2={handleAddToWatchlist}
              />
              <div
                className="justify-center flex-nowrap mt-4 overflow-x-auto grid grid-cols-1 lg:grid-cols-9 chart-options"
                style={{
                  paddingBottom: isMobileView
                    ? savedCharts.length === 0
                      ? "70px"
                      : "20px"
                    : "40px",
                }}
              >
                <ChartSettingsControl
                  setting={setting}
                  setSetting={setSetting}
                  className="md:flex-shrink-1"
                />
                <ChartType
                  setting={setting}
                  setSetting={setSetting}
                  className="md:flex-shrink-1"
                />
                <Overlays
                  setting={setting}
                  setSetting={setSetting}
                  isSubmit={isOverlaySubmit}
                  setIsSubmit={setIsOverlaySubmit}
                  loader={overlayloader}
                  className="md:flex-shrink-1"
                />
                <Indicators
                  setting={setting}
                  setSetting={setSetting}
                  isSubmit={isIndicatorSubmit}
                  setIsSubmit={setIsIndicatorSubmit}
                  loader={indicatorloader}
                  className="md:flex-shrink-1"
                  setRows={setRows}
                  rows={rows}
                  initialState={initialState}
                />
              </div>
            </>
          ) : (
            <ChartError error={error} />
          )}
          <SavedCharts
            data={data}
            savedCharts={savedCharts}
            mobileView={isMobileView}
            settings={settings}
            onTouchStart={handleSlideStart}
            onTouchEnd={handleSlideEnd}
            callbackfn={(chart, index) => (
              <SaveChartImage
                key={index}
                chart={chart}
                slide={isSlide}
                prop2={() => {}}
                prop3={() => {
                  handleSavedChartClick(chart);
                }}
                type={1}
                toggleDropdown1={toggleDropdown1}
                dropdownStates1={dropdownStates1}
                onShareChartClick={onShareChartClick}
                shareChartAsPost={shareChartAsPost}
                index={index}
                onShareChartDeleteClick={onShareChartDeleteClick}
              />
            )}
            callbackfn1={(chart, index) => (
              <SaveChartImage
                key={index}
                chart={chart}
                slide={isSlide}
                prop2={() => {}}
                prop3={() => {
                  handleSavedChartClick(chart);
                }}
                type={2}
                onShareChartClick={onShareChartClick}
                shareChartAsPost={shareChartAsPost}
                toggleDropdown1={toggleDropdown1}
                dropdownStates1={dropdownStates1}
                index={index}
                onShareChartDeleteClick={onShareChartDeleteClick}
              />
            )}
            preview={preview}
            onClick={() => {
              setPreview(false);
            }}
            src={activeImage}
            onShareChartClick={onShareChartClick}
            shareChartAsPost={shareChartAsPost}
          />
          {showModal && (
            <div className="fixed z-[100] inset-0 overflow-y-auto">
              <div className="absolute inset-0 bg-black opacity-75"></div>

              <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
                <div
                  className="fixed inset-0 transition-opacity"
                  aria-hidden="true"
                >
                  <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <span
                  className="hidden sm:inline-block sm:align-middle sm:h-screen"
                  aria-hidden="true"
                >
                  &#8203;
                </span>
                <div className="px-2 fixed z-[100] inset-0 overflow-y-auto flex items-center justify-center">
                  <div className="bg-white rounded-lg  w-full shadow-xl max-w-lg mx-auto sm:my-8 p-6">
                    {/* Logo */}
                    <div className="flex justify-center items-center mb-4">
                      <img
                        src={"/qushi_logo.png"}
                        alt="Logo"
                        className="h-16 w-auto"
                      />
                    </div>

                    <h2 className="text-lg font-bold text-primaryColor mb-4">
                      Are you sure you want to delete this chart?
                    </h2>

                    <div className="flex items-center justify-between">
                      <button
                        className="bg-primaryColor hover:bg-primaryColor text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        onClick={handleDeleteChart}
                      >
                        Yes
                      </button>
                      <button
                        className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        onClick={() => setShowModal(false)}
                      >
                        No
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {showModalChart && (
            <div className="fixed z-[100] inset-0 overflow-y-auto">
              <div className="absolute inset-0 bg-black opacity-75"></div>

              <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
                <div
                  className="fixed inset-0 transition-opacity"
                  aria-hidden="true"
                >
                  <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <span
                  className="hidden sm:inline-block sm:align-middle sm:h-screen"
                  aria-hidden="true"
                >
                  &#8203;
                </span>
                <div className="px-2 fixed z-[100] inset-0 overflow-y-auto flex items-center justify-center">
                  <div className="bg-white rounded-lg w-full shadow-xl max-w-lg mx-auto sm:my-8 p-6">
                    {/* Logo */}
                    <div className="flex justify-center items-center mb-4">
                      <img
                        src={"/qushi_logo.png"}
                        alt="QUSHi"
                        className="h-12 w-auto"
                      />
                    </div>

                    {/* Composer — same B/I/U + emoji toolbar as Add Post */}
                    <PostRichTextEditor
                      value={inputValue}
                      onChange={setInputValue}
                      placeholder="What's the setup?"
                      isMobileView={isMobileView}
                    />

                    {/* Actions */}
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mt-5">
                      <button
                        className="w-full sm:w-auto bg-teal-800 hover:bg-teal-900 text-white font-semibold py-2.5 px-6 rounded-lg disabled:opacity-60 focus:outline-none"
                        onClick={handleShare}
                        disabled={sharingInProgress}
                      >
                        Show Your Work
                      </button>
                      <button
                        className="w-full sm:w-auto border border-gray-300 text-gray-700 hover:bg-gray-50 font-medium py-2.5 px-6 rounded-lg focus:outline-none"
                        onClick={() => setShowModalChart(false)}
                      >
                        Never Mind
                      </button>
                    </div>

                    {/* Lock notice */}
                    <p className="text-xs font-medium text-gray-500 text-center mt-4">
                      Posts lock after 3 minutes. Your call is on the record.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Direct Share Chart Modal */}
          {showDirectShareModal && (
            <div className="fixed z-[100] inset-0 overflow-y-auto">
              <div className="absolute inset-0 bg-black opacity-75"></div>

              <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
                <div
                  className="fixed inset-0 transition-opacity"
                  aria-hidden="true"
                >
                  <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <span
                  className="hidden sm:inline-block sm:align-middle sm:h-screen"
                  aria-hidden="true"
                >
                  &#8203;
                </span>
                <div className="px-2 fixed z-[100] inset-0 overflow-y-auto flex items-center justify-center">
                  <div className="bg-white rounded-lg w-full shadow-xl max-w-lg mx-auto sm:my-8 p-6">
                    {/* Logo */}
                    <div className="flex justify-center items-center mb-4">
                      <img
                        src={"/qushi_logo.png"}
                        alt="Logo"
                        className="h-16 w-auto"
                      />
                    </div>

                    {/* Composer — same B/I/U + emoji toolbar as Add Post */}
                    <PostRichTextEditor
                      value={directShareDescription}
                      onChange={setDirectShareDescription}
                      placeholder="What's the setup?"
                      isMobileView={isMobileView}
                    />

                    {/* Actions */}
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mt-5">
                      <button
                        className="w-full sm:w-auto bg-teal-800 hover:bg-teal-900 text-white font-semibold py-2.5 px-6 rounded-lg disabled:opacity-60 focus:outline-none"
                        onClick={handleDirectShare}
                        disabled={directShareInProgress}
                      >
                        Show Your Work
                      </button>
                      <button
                        className="w-full sm:w-auto border border-gray-300 text-gray-700 hover:bg-gray-50 font-medium py-2.5 px-6 rounded-lg focus:outline-none"
                        onClick={() => {
                          setShowDirectShareModal(false);
                          setDirectShareDescription("");
                          setDirectShareImageFile(null);
                        }}
                      >
                        Never Mind
                      </button>
                    </div>

                    {/* Lock notice */}
                    <p className="text-xs font-medium text-gray-500 text-center mt-4">
                      Posts lock after 3 minutes. Your call is on the record.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          <AddNotification
            open={isNotificationOpen}
            handleClose={handleClose}
            handleSaveNotification={handleSaveNotification}
            handleAPICall={handleAPICall}
            activeTab={activeTab}
            onClick={() => handleTabClick(1)}
            onClick1={() => handleTabClick(2)}
            value={price}
            onChange={handleInputChange}
          />
          <FollowersListModal
            isOpen={isFollowersOpen}
            // handleShareToFollowers={handleShareToFollowers}
            handleShareCancel={handleShareCancel}
          >
            <div>
              <ul className="px-4 max-h-80 overflow-auto mb-2">
                {followersList && followersList.length > 0 ? (
                  followersList.map((val, index) => {
                    return (
                      <li key={val?.sender?.id} className="">
                        <div className="flex justify-between py-2 bg-gray-100 px-2 rounded-lg mb-4">
                          <div className="flex px-1">
                            <img
                              alt="profile_image"
                              className="object-cover rounded-full w-10 h-10"
                              src={val?.sender?.image}
                            />
                            <p className="px-1 ml-1 mt-2">
                              {val?.sender?.user_name}
                            </p>
                          </div>
                          <div className="px-1">
                            <button
                              disabled={
                                selectedIndices.includes(index) ? true : false
                              }
                              className={
                                selectedIndices.includes(index)
                                  ? "text-primaryColor border border-primaryColor rounded-lg px-2 py-2 text-sm cursor-pointer"
                                  : "text-white bg-primaryColor rounded-lg px-2 py-2 text-sm cursor-pointer"
                              }
                              onClick={() =>
                                handleShareToFollowers(val?.sender?.id, index)
                              }
                            >
                              Send
                            </button>
                          </div>
                        </div>
                      </li>
                    );
                  })
                ) : (
                  <div className="text-center font-bold text-black py-4 px-4 mt-3 mb-4">
                    <p>No Followers Found</p>
                  </div>
                )}
              </ul>
            </div>
          </FollowersListModal>
          {preview1 && (
            <div
              className="flex"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}
              onClick={handlePreview1Close}
            >
              <img
                src={activeImage1}
                alt="Preview"
                style={{ maxWidth: "80%", maxHeight: "90%" }}
              />
            </div>
          )}

          {showModal1 && !loading1 && (
            <div
              className="fixed inset-0 z-[60] flex items-end justify-center bg-black/70"
              onClick={() => setShowModal1(false)}
            >
              <div
                className="bg-white rounded-t-2xl w-full max-w-lg p-4 shadow-2xl border-t border-x border-gray-700"
                onClick={(e) => e.stopPropagation()}
                style={{
                  animation: 'slideUp 0.3s ease-out forwards'
                }}
              >
                {/* Handle bar */}
                <div className="flex justify-center mb-3">
                  <div className="w-10 h-1 bg-gray-600 rounded-full"></div>
                </div>

                {/* Header */}
                <div className="flex justify-between items-center mb-4">
                  <h3 className="text-primaryColor text-lg font-semibold">Choose Watchlists</h3>
                  <button
                    onClick={() => setShowModal1(false)}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                <div className="space-y-2 max-h-64 overflow-y-auto">
                  {/* Select All checkbox */}
                  <label className="flex items-center space-x-3 p-3 bg-white border border-primaryColor rounded-lg cursor-pointer hover:bg-primaryColor transition-colors hover:text-white">
                    <input
                      type="checkbox"
                      className="w-4 h-4 accent-primaryColor"
                      checked={
                        watchlists.length > 0 &&
                        watchlists.every((wl) => selected1[wl.id])
                      }
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        const newSelected1 = {};
                        if (isChecked) {
                          watchlists.forEach((wl) => {
                            newSelected1[wl.id] = true;
                          });
                        }
                        setSelected1(newSelected1);
                      }}
                    />
                    <span className="text-white font-medium">Select All</span>
                  </label>

                  {/* Individual checkboxes */}
                  {watchlists.map((wl) => (
                    <label key={wl.id} className="flex items-center space-x-3 p-3 bg-white border border-primaryColor rounded-lg cursor-pointer hover:bg-primaryColor transition-colors hover:text-white">
                      <input
                        type="checkbox"
                        className="w-4 h-4 accent-primaryColor"
                        checked={selected1[wl.id] || false}
                        onChange={() => handleCheckboxChange(wl.id)}
                      />
                      <span className="text-gray-300">{wl.name}</span>
                    </label>
                  ))}
                </div>

                <div className="flex justify-center mt-4">
                  <button
                    className="w-full px-4 py-3 bg-primaryColor hover:bg-primaryColor-dark text-white font-semibold rounded-lg transition-colors"
                    onClick={handleConfirm}
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </PageContainer>
    </>
  );
};

const ArrowButton = ({ imgSrc, onClick, type, isMobileView }) => {
  return (
    <button
      onClick={onClick}
      className={
        isMobileView
          ? `absolute top-1/2 z-10 -translate-y-1/2 cursor-pointer ${
              type === "left"
                ? " left-7 lg:left-[-25px]"
                : "right-4 lg:right-[-25px]"
            } rounded-full p-2 transition duration-150 ease-in-out`
          : `absolute top-1/2 z-10 -translate-y-1/2 cursor-pointer ${
              type === "left"
                ? "left-5 lg:left-[-25px]"
                : "right-4 lg:right-[-25px]"
            } rounded-full p-2 transition duration-150 ease-in-out`
      }
      style={{
        marginTop: "-12px",
        marginLeft: type === "left" && isMobileView ? "-42px" : "12px",
        marginRight: type === "right" && isMobileView ? "-35px" : "12px",
      }}
    >
      <FontAwesomeIcon className="text-[#5f5f5f]" icon={imgSrc} size="sm" />
    </button>
  );
};

export default ChartSearchSection;
